module.exports = __webpack_public_path__ + "img/coupon.8966cc1a.svg";